export const toTeamCard = ({
  _id,
  id,
  userId,
  username,
  role,
  status,
  imageUrl,
  image,
  accessAreas,
}) => {
  const resolvedUser =
    typeof userId === "object" && userId !== null ? userId : null;
  const rawImage =
    (Array.isArray(resolvedUser?.imageUrl)
      ? resolvedUser.imageUrl.find(Boolean)
      : resolvedUser?.imageUrl || resolvedUser?.image) ||
    (Array.isArray(imageUrl) ? imageUrl.find(Boolean) : imageUrl) ||
    image ||
    "";

  return {
    id: _id || id,
    membershipId: _id || id,
    userId: resolvedUser?._id || (typeof userId === "string" ? userId : ""),
    name: resolvedUser?.fullname || resolvedUser?.email || "Registered user",
    email: resolvedUser?.email || "",
    username,
    role: role === "admin" ? "Admin" : "Shop member",
    rawRole: role || "member",
    status: status || "active",
    imageUrl: rawImage || "",
    user: resolvedUser,
    accessAreas: Array.isArray(accessAreas) ? accessAreas : [],
  };
};

